import React from "react";
import styled from "styled-components";
import { Flex } from "../../components";

const ModalWrapper = styled(Flex)`
  display: ${({ open }) => (open ? "display" : "none")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
`;

const ModalTextWrapper = styled(Flex)`
  width: 25vw;
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: .5em;
  background: #fff;
  @media(max-width:767px){
    width:300px !important;
  }
`;
const Cancel = styled.p`
  color: #9a9a9a;
  font-weight: 600;
  font-size: 18px;
`
const Submit = styled.p`
  color: #673AB7;
  font-weight: 600;
  font-size: 18px;
  margin-left: 50px;
`

const Modal = ({ open, handleModalToggle, handleSubmit,dialogTitle }) => (
  
  <ModalWrapper center open={open}>
    <ModalTextWrapper column>
      <p style={{fontSize:'14px',fontWeight:'bold',marginBottom:'20px'}} >{dialogTitle}</p>
      <Flex justifyBetween style = {{margin: 'auto'}}>
        <Cancel  onClick={handleModalToggle}>CANCEL</Cancel>
        <Submit onClick={handleSubmit}>SUBMIT</Submit>
      </Flex>
    </ModalTextWrapper>
  </ModalWrapper>
);

export default Modal;
